import { Icon } from "@fortawesome/fontawesome-svg-core";
import {
  faHouse,
  faCog,
  faLifeRing,
  faCartShopping,
  faBagShopping,
  faSquareList,
  faTags,
  faFileInvoice,
} from "@fortawesome/pro-light-svg-icons";
import { paths } from "~/router/paths";
import { INavItem } from "~/types/routing";

export const navItems: Array<INavItem> = [
  {
    namePath: "nav.home",
    path: paths.app.home,
    icon: faHouse as Icon,
  },
  {
    namePath: "nav.import_list",
    path: paths.app.importList,
    icon: faSquareList as Icon,
  },
  {
    namePath: "nav.live_products",
    path: paths.app.liveProducts,
    icon: faTags as Icon,
  },
  {
    namePath: "nav.orders",
    path: paths.app.orders,
    icon: faCartShopping as Icon,
  },
  {
    namePath: "nav.sample_orders",
    path: paths.app.sampleOrders,
    icon: faBagShopping as Icon,
  },
  {
    namePath: "nav.branding",
    path: paths.app.branding,
    icon: faFileInvoice as Icon,
  },
  {
    namePath: "settings.title",
    path: paths.settings.plans,
    icon: faCog as Icon,
  },
  {
    namePath: "nav.help_center",
    path: "https://help.jubilee.beauty/en/",
    openInNewTab: true,
    icon: faLifeRing as Icon,
  },
];
